export const UNEXPECTED_ERROR_MSG = 'Unexpected error occurred, please try again'